import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../modules';
import {
  updateProfileField,
  EditProfileInputField,
  initProfileEditField
} from '../modules/mypage';

export default function useQueryParam() {
  const { profile } = useSelector((state: RootState) => state);
  const dispatch = useDispatch();

  const onInitProfileField = useCallback(
    () => dispatch(initProfileEditField()),
    [dispatch]
  );

  const onUpdateProfileField = useCallback(
    (payload: EditProfileInputField) => dispatch(updateProfileField(payload)),
    [dispatch]
  );

  return {
    profile,
    onInitProfileField,
    onUpdateProfileField
  };
}
